"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("@mui/material"),t=require("@mui/material/styles"),o=require("../../assets/icons/Search.js");require("react/jsx-runtime");const n=t.styled("div")(()=>`
    position: relative;
    margin: 8px 16px;
  `),i=t.styled(r.TextField)(({theme:e})=>`
    && {
      & .${r.inputBaseClasses.root} {
        font-weight: 700;
        font-family: Lato;
        background: ${e.palette.common.white};
        border-radius: 8px;
        border-color: ${e.palette.grey[600]};
        width: 100%;
        margin: 0;
 
        input {
          padding: 8px 0;
          height: auto;
          font: inherit;
          font-size: 14px;
 
          &:hover::before, &:hover::after, &::before, &::after {
            border: none;
          }
        }
      }
    }
  `),a=t.styled(o)(({theme:e})=>`
    position: absoulte;
    z-index: 2;
    top: 9px;
    left: 16px;
    width: 16px;
    height: 16px;
    color: ${e.palette.grey[700]};
  `);exports.SearchIcon=a;exports.SearchInput=i;exports.SearchInputWrapper=n;
